import { createContext, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const AudioContext = createContext()

const AudioProvider = ({ children }) => {
  const boastAudioRef = useRef(null)

  useEffect(() => {
    // Load the audio file when website loads (but don't play it)
    if (!boastAudioRef.current) {
      boastAudioRef.current = new Audio('/audio/boast.m4a')
      boastAudioRef.current.preload = 'auto'
      boastAudioRef.current.loop = true
      boastAudioRef.current.volume = 0.10 // Very low volume for background feel (reduced from 0.03)
    }
  }, [])

  return (
    <AudioContext.Provider value={{ boastAudioRef }}>
      {children}
    </AudioContext.Provider>
  )
}

AudioProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { AudioProvider, AudioContext }

